import React from "react";
import Scrollbars from "react-custom-scrollbars-2";

import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import InputArea from "components/form/InputArea";
import InputMobileWoCode from "components/form/InputMobileWoCode";
import SelectStateSingle from "components/form/SelectStateSingle";
import Error from "components/form/Error";

import useVendorRatesLinkCreateSubmit from "hooks/useVendorRatesLinkCreateSubmit";
import SelectCityAll from "components/form/SelectCityAll";

const VendorRatesDrawer = ({ onModalOpen }) => {
    const {
        trigger,
        register,
        handleSubmit,
        onSubmit,
        errors,
        loading,
        selectedState,
        selectedCountryCode,
        handleStateChange,
        selectedCity,
        handleCityChange
    } = useVendorRatesLinkCreateSubmit(null, onModalOpen);

    return (
        <>
            <div className="w-full p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
                <Title title="Create Rate Link" />
            </div>

            <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 dark:bg-gray-700 dark:text-gray-200">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="px-6 pt-8 pb-32">

                        <div className="grid grid-cols-12 gap-5">

                            {/* Vendor Name */}
                            <div className="col-span-12">
                                <LabelArea
                                    required
                                    label="Vendor Name"
                                />

                                <InputArea
                                    trigger={trigger}
                                    register={register}
                                    label="Vendor Name"
                                    name="vendor_name"
                                    placeholder="Enter Vendor Name"
                                    type="text"
                                    maxLength={120}
                                    pattern={/^[A-Za-z\s]+$/}
                                />

                                <Error errorName={errors.vendor_name} />
                            </div>

                            {/* State */}
                            <div className="col-span-12">
                                <LabelArea
                                    required
                                    label="State"
                                />

                                <SelectStateSingle
                                    register={register}
                                    label="State"
                                    name="state"
                                    selectedCountryId={110}
                                    selectedState={selectedState}
                                    handleStateChange={handleStateChange}
                                />
                                <Error errorName={errors.state_id} />
                            </div>

                            <div className="col-span-12">
                                <LabelArea required label={"City"} />
                                <SelectCityAll
                                    register={register}
                                    label="City"
                                    name="city_id"
                                    selectedState={selectedState}
                                    selectedCity={selectedCity}
                                    handleCityChange={handleCityChange}
                                />

                                <Error errorName={errors.city_id} />
                            </div>

                            {/* Phone Number */}
                            <div className="col-span-12">
                                <LabelArea
                                    required
                                    label="Phone Number"
                                />

                                <InputMobileWoCode
                                    trigger={trigger}
                                    register={register}
                                    label="Phone Number"
                                    name="contact_no"
                                    placeholder="9876543210"
                                    type="number"
                                    minLength={10}
                                    maxLength={10}
                                    pattern={/^\d{10}$/}
                                    CountryCode={selectedCountryCode}
                                    CountryCodeName="call_prefix"
                                />

                                <Error errorName={errors.contact_no} />
                            </div>

                        </div>

                        <div className="flex justify-end mt-8">
                            <button
                                type="submit"
                                disabled={loading}
                                className={`px-6 py-2 rounded-md text-white font-medium transition-colors duration-200 ${loading
                                    ? "bg-gray-400 cursor-not-allowed"
                                    : "bg-green-600 hover:bg-green-700"
                                    }`}
                            >
                                {loading ? "Creating..." : "Create Link"}
                            </button>
                        </div>

                    </div>
                </form>
            </Scrollbars>
        </>
    );
};

export default VendorRatesDrawer;